import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./components/Login";
import Sidebar, { SidebarToggleButton } from "./components/Sidebar";
import Dashboard from "./components/Dashboard";
import UsuariosList from "./components/UsuariosList";
import GastosList from "./components/GastosList";
import JornadaList from "./components/JornadaList";
import LoginTrabajador from "./components/LoginTrabajador";
import EmpleadosList from "./components/EmpleadosList";
import AdministradoresList from "./components/AdministradoresList";
import FichajesSyncList from "./components/FichajesSyncList";
import "react-toastify/dist/ReactToastify.css";

const PrivateRoute = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();

  if (loading) {
    return <div className="text-center mt-5">Cargando...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/gastos" />;
  }

  return children;
};

const Layout = ({ children }) => {
  const [showSidebar, setShowSidebar] = React.useState(false);

  // Cierra el sidebar al cambiar de tamaño a desktop
  React.useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setShowSidebar(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {/* Botón hamburguesa solo en móvil */}
      <SidebarToggleButton onClick={() => setShowSidebar(true)} />
      {/* Sidebar como drawer en móvil, fijo en desktop */}
      <div>
        <div className="d-none d-md-block">
          <Sidebar show={true} />
        </div>
        <div className="d-md-none">
          <Sidebar show={showSidebar} onClose={() => setShowSidebar(false)} />
        </div>
      </div>
      <div className="main-content">{children}</div>
    </>
  );
};

const AppRoutes = () => {
  const { isAdmin } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/login-trabajador" element={<LoginTrabajador />} />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/usuarios"
        element={
          <PrivateRoute requireAdmin>
            <Layout>
              <UsuariosList />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/gastos"
        element={
          <PrivateRoute>
            <Layout>
              <GastosList />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/jornadas"
        element={
          <PrivateRoute>
            <Layout>
              <JornadaList />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/empleados"
        element={
          <PrivateRoute requireAdmin>
            <Layout>
              <EmpleadosList />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/sincronizacion-fichajes"
        element={
          <PrivateRoute requireAdmin>
            <Layout>
              <FichajesSyncList />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/administradores"
        element={
          <PrivateRoute requireAdmin>
            <Layout>
              <AdministradoresList />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route path="/" element={<Navigate to={isAdmin ? "/dashboard" : "/gastos"} replace />} />
    </Routes>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <AppRoutes />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </AuthProvider>
  );
};

export default App;
